export const appName = 'ip'
